const moment = require('moment')
export const alertOccurenceSchedule = {
    name: '',
    account: '',
    client: '',
    site: '',
    equipment: '',
    frequency: '',
    category: 'ALERT_CHECK',
    frequencyMonth: {
        day: '',
    },
    frequencyYear: {
        month: '',
        day: '',
    },
    weeklyDays: [],
    beginDate: moment().format('YYYY-MM-DD'),
    endDate: null,
    beginHour: '',
    endHour: '',
    status: 'ACTIVE',
    alertConfig: {
        alertType: '',
        fixedInterval: 0,
        durationMin: 0,
        volumeLevel: 0,
        randomMin: 0,
        randomMax: 0,
    },
}